import { Component, HostBinding } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent{
    test : Date = new Date();
}



// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/shared/footer/footer.component.ts